import React from 'react';

import classnames from 'classnames';

import { ListCore, type ListCoreProps } from '../ListCore';

import styles from './SecondaryList.module.scss';

export const SecondaryList = ({ headerClassName, listClassName, ...props }: ListCoreProps) => {
    return (
        <div className={styles.container}>
            <ListCore
                {...props}
                headerClassName={classnames(styles.header, headerClassName)}
                listClassName={listClassName}
                rowClassName={styles.row}
            />
        </div>
    );
};
